import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Permission } from '@fly/shared';

export const EXPIRATION_TIME_VALUES = {
  '7days': 7 * 24 * 60 * 60,
  '30days': 30 * 24 * 60 * 60,
  '60days': 60 * 24 * 60 * 60,
  '365days': 365 * 24 * 60 * 60,
  unlimited: 0,
} as const;

export function useExpirationTimeOptions() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        textValue: t(
          'app.dashboard.token_management.fields.expiration_time.7_days',
          { defaultValue: '7 days' }
        ),
        value: EXPIRATION_TIME_VALUES['7days'].toString(),
      },
      {
        textValue: t(
          'app.dashboard.token_management.fields.expiration_time.30_days',
          { defaultValue: '30 days' }
        ),
        value: EXPIRATION_TIME_VALUES['30days'].toString(),
      },
      {
        textValue: t(
          'app.dashboard.token_management.fields.expiration_time.60_days',
          { defaultValue: '60 days' }
        ),
        value: EXPIRATION_TIME_VALUES['60days'].toString(),
      },
      {
        textValue: t(
          'app.dashboard.token_management.fields.expiration_time.365_days',
          { defaultValue: '365 days' }
        ),
        value: EXPIRATION_TIME_VALUES['365days'].toString(),
      },
      {
        textValue: t(
          'app.dashboard.token_management.fields.expiration_time.unlimited',
          { defaultValue: 'Unlimited' }
        ),
        value: EXPIRATION_TIME_VALUES['unlimited'].toString(),
      },
    ],
    [t]
  );
}

export function usePermissionsOptions() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        textValue: t(
          'app.dashboard.token_management.fields.permission_options.read_only',
          { defaultValue: 'Read Only' }
        ),
        value: Permission.READ,
      },
      {
        textValue: t(
          'app.dashboard.token_management.fields.permission_options.read_write',
          { defaultValue: 'Read & Write' }
        ),
        value: Permission.READ_WRITE,
      },
    ],
    [t]
  );
}
